import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension"

import {
  allCompanyReducer,
  allCompanyReducer2,
  calenderReducer,
  userLoginReducer,
  forgotPasswordReducer,
  userReducer,
  companyMasterReducer,
  sectorMasterReducer,
  industryMasterReducer,
  turnAroundMasterReducer,
  resultFilterInputReducer,
  resetPasswordReducer,
  valuationReducer,
  valuationFilterReducer,
  DeliveryDataReducer,
  DeliveryDataFilterReducer,
  singleCompanyReducer,
  SingleCompanyValuationReducer,
  UploadDocumentReducer,
  SingleCompanyCommentsReducer,
  UploadDocumentAnalystNotesReducer,
  AboutUsUpdateReducer,
  SendNotificationReducer,
  FIIsModelReducer,
  FIIsSectorReducer,
  FIIsTopBottomReducer,
  FIISDateMasterReducer,
  RatioTooltipReducer,
  ForensicTabShowHideReducer,
  ForensicModelCommentsReducer,
  
} from './reduces/userReducer'

import {
  SegmentReducer,
  vdrGroupsReducer,
  vdrLevelReducer,
  vdrCompanyReducer,
  vdrHomeReducer,
  vdrUploadImageReducer,
  ipAddressReducer,
  vdrSingleCompanyReducer,
  vdrPDFLinkReducer,
  mediaModelReducer,
  vdrMediaDataReducer,
  vdrData20YearsQuarterlyReducer,
  vdrData20YearsReducer,
  vdrPeerToPeerReducer,
  vdrSortDataReducer,
  vdrSortUpdateDataReducer,
  vdrFavoriteReducer,
  FavoriteCompanyReducer,
  AssignEmployeeReducer,
  vdrMediaReducer,
  filesLogReducer,
  vdrEmployeeReducer,
  PriceActionFilterReducer,
  PriceActionReducer,
  vdrMediaGroupReducer,
  priceIndexMasterReducer,
  dateAPIReducer,
  ForensicReducer,
  MessageReducer,
  GetOmakaraUsersReducer,
  quarterlyReviewReducer,
  quarterlySegmentReducer,
  vdrHomeCompaniesReducer,
} from './reduces/VdrReducer';
import { loginReducer, adminUserListReducer, userProfileReducer, profileUpdateReducer, googleLoginReducer } from "./reduces/capitalReducer";



const reducer = combineReducers({
  users: userReducer,
  loginData: loginReducer,
  adminUserListReducer,
  profileUpdateReducer,
  googleLoginReducer,
  userProfileReducer,
  // loginData: userLoginReducer,
  allCompanies: allCompanyReducer,
  allCompanies2: allCompanyReducer2,
  calenderData: calenderReducer,
  companyMasterData: companyMasterReducer,
  sectorMasterData: sectorMasterReducer,
  industryMasterData: industryMasterReducer,
  turnAroundMasterData: turnAroundMasterReducer,
  resultFilterInput: resultFilterInputReducer,
  resetPasswordData: resetPasswordReducer,
  valuationReducerData: valuationReducer,
  valuationFilterReducerData: valuationFilterReducer,
  DeliveryDataReducerData: DeliveryDataReducer,
  DeliveryDataFilterReducerData: DeliveryDataFilterReducer,
  ForgotPasswordReducerData: forgotPasswordReducer,
  SingleCompanyCommentsReducer,
  UploadDocumentAnalystNotesReducer,
  singleCompanyReducer,
  UploadDocumentReducer,
  SingleCompanyValuationReducer,
  vdrGroupsReducer,
  vdrLevelReducer,
  vdrCompanyReducer,
  vdrHomeReducer,
  vdrUploadImageReducer,
  ipAddressReducer,
  vdrSingleCompanyReducer,
  vdrPDFLinkReducer,
  vdrMediaDataReducer,
  mediaModelReducer,
  vdrData20YearsQuarterlyReducer,
  vdrData20YearsReducer,
  vdrPeerToPeerReducer,
  vdrSortDataReducer,
  vdrSortUpdateDataReducer,
  vdrFavoriteReducer,
  FavoriteCompanyReducer,
  vdrEmployeeReducer,
  AssignEmployeeReducer,
  vdrMediaReducer,
  filesLogReducer,
  PriceActionFilterReducer,
  PriceActionReducer,
  vdrMediaGroupReducer,
  priceIndexMasterReducer,
  dateAPIReducer,
  ForensicReducer,
  MessageReducer,
  GetOmakaraUsersReducer,
  AboutUsUpdateReducer,
  SendNotificationReducer,
  FIIsModelReducer,
  FIIsSectorReducer,
  FIIsTopBottomReducer,
  FIISDateMasterReducer,
  RatioTooltipReducer,
  ForensicTabShowHideReducer,
  ForensicModelCommentsReducer,
  SegmentReducer,
  quarterlyReviewReducer,
  quarterlySegmentReducer,
  vdrHomeCompaniesReducer,
});
console.log(JSON.parse(localStorage.getItem("user")));
let initialState = {
  loginData : {
    "loading":true,
    "data": localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).data : [],
    "isAuthenticated": localStorage.getItem("user") ? true : false,
    "isAdmin":localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).data?.user?.roles[0]?.name : "",
    // "isAdmin":"admin",
    "msg":null,
    "error":null,
  }
};

const middleware = [thunk];

const Store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default Store;
